












import { mapGetters } from "vuex";
import { General } from "@/utils/constants";

export default {
  name: "NoListMessager",
  props: {
    message: {
      type: String,
      default: General.MESSAGES.NO_RESULT_FOUND.toUpperCase()
    }
  },

  data() {
    return {
      General
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  }
};
